
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5389"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5389"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kAXkN", function(module, exports) {

$parcel$export(module.exports, "Navigation", () => $efe53200213010c0$export$b8a61e5c71402559);
/**
 * Navigation Component
 * Componente reutilizável para a navegação fixa no topo das páginas
 */ class $efe53200213010c0$export$b8a61e5c71402559 {
    constructor(options = {}){
        this.options = {
            homeLink: options.homeLink || '#',
            links: options.links || [],
            ...options
        };
    }
    render() {
        const linksHTML = this.options.links.map((link)=>`<a href="${link.href}" class="text-sm font-medium text-slate-600 hover:text-brand transition-colors ${link.hidden ? 'hidden md:block' : ''}">${link.label}</a>`).join('');
        const ctaButton = this.options.ctaButton ? `<a href="${this.options.ctaButton.href}" class="px-5 py-2.5 bg-brand hover:bg-brand-hover text-white rounded-lg transition-all shadow-lg shadow-brand/20 hover:shadow-brand/30 font-medium ${this.options.ctaButton.class || ''}">${this.options.ctaButton.label}</a>` : '';
        return `
      <nav class="fixed w-full z-50 top-0 left-0 bg-white/80 backdrop-blur-lg border-b border-slate-200 transition-all duration-300" id="navbar">
        <div class="max-w-6xl mx-auto px-6 h-20 flex items-center justify-between">
          <!-- Logo -->
          <a href="${this.options.homeLink}" class="text-xl font-bold text-text-title tracking-tight hover:text-brand transition-colors">
            Gabriel Mendon\xe7a
          </a>

          <!-- Desktop Menu -->
          <div class="hidden md:flex items-center gap-8">
            ${linksHTML}
            ${ctaButton}
          </div>

          <!-- Mobile Menu Button -->
          <button id="mobile-menu-btn" class="md:hidden text-slate-700 text-2xl p-2 hover:bg-slate-100 rounded-lg transition-colors">
            <i class="ph ph-list"></i>
          </button>
        </div>

        <!-- Mobile Menu Dropdown -->
        <div id="mobile-menu" class="hidden md:hidden absolute top-20 left-0 w-full bg-white border-b border-slate-200 py-6 px-6 flex flex-col gap-4 shadow-xl">
          ${this.options.links.map((link)=>`<a href="${link.href}" class="text-lg font-medium text-slate-700 hover:text-brand transition-colors mobile-link">${link.label}</a>`).join('')}
          ${this.options.ctaButton ? `<a href="${this.options.ctaButton.href}" class="text-lg font-medium text-brand mobile-link">${this.options.ctaButton.label}</a>` : ''}
        </div>
      </nav>
    `;
    }
    attachEventListeners() {
        const mobileMenuBtn = document.getElementById('mobile-menu-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileLinks = document.querySelectorAll('.mobile-link');
        if (mobileMenuBtn && mobileMenu) {
            mobileMenuBtn.addEventListener('click', ()=>{
                mobileMenu.classList.toggle('hidden');
            });
            mobileLinks.forEach((link)=>{
                link.addEventListener('click', ()=>{
                    mobileMenu.classList.add('hidden');
                });
            });
        }
    }
    mount(selector) {
        const element = document.querySelector(selector);
        if (element) {
            element.innerHTML = this.render();
            this.attachEventListeners();
        }
    }
}
var $efe53200213010c0$export$2e2bcd8739ae039 = $efe53200213010c0$export$b8a61e5c71402559;

});

parcelRegister("hqDZ9", function(module, exports) {

$parcel$export(module.exports, "ProjectCard", () => $cb03e19fc8d39638$export$bacf8f04493bf68c);
/**
 * ProjectCard Component
 * Componente para representar um projeto no portfólio
 */ class $cb03e19fc8d39638$export$bacf8f04493bf68c {
    constructor(options = {}){
        this.title = options.title || "T\xedtulo do Projeto";
        this.description = options.description || "Descri\xe7\xe3o do projeto";
        this.icon = options.icon || 'ph-laptop';
        this.image = options.image || null;
        this.tags = options.tags || [];
    }
    render() {
        const thumbnail = this.image ? `<img src="${this.image}" alt="${this.title}" loading="lazy" class="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-500">` : `<i class="ph ${this.icon} text-6xl text-slate-300 group-hover:text-brand transition-colors transform group-hover:scale-110 duration-500"></i>`;
        return `
      <article class="group bg-white rounded-2xl overflow-hidden border border-slate-200 hover:border-brand/50 transition-all duration-300 shadow-sm hover:shadow-hover">
        <!-- Thumbnail -->
        <div class="h-52 bg-slate-100 relative overflow-hidden flex items-center justify-center group-hover:bg-slate-50 transition-colors">
          <div class="absolute inset-0 bg-gradient-to-tr from-brand/10 to-transparent opacity-50"></div>
          ${thumbnail}
        </div>
        
        <div class="p-6">
          <h3 class="text-xl font-bold text-slate-900 mb-2 group-hover:text-brand transition-colors">${this.title}</h3>
          <p class="text-sm text-slate-500 mb-4 line-clamp-3">
            ${this.description}
          </p>
          
          <div class="flex flex-wrap gap-2 mb-2">
            ${this.tags.map((tag)=>`<span class="px-2 py-1 text-[10px] uppercase font-bold tracking-wide bg-slate-100 text-slate-600 rounded border border-slate-200">${tag}</span>`).join('')}
          </div>
        </div>
      </article>
    `;
    }
}
var $cb03e19fc8d39638$export$2e2bcd8739ae039 = $cb03e19fc8d39638$export$bacf8f04493bf68c;

});

parcelRegister("7Rotq", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $5b90779196215fa1$export$a06f1c675e846f6f);
/**
 * Footer Component
 * Componente de rodapé reutilizável
 */ class $5b90779196215fa1$export$a06f1c675e846f6f {
    constructor(options = {}){
        this.copyrightText = options.copyrightText || "Gabriel Mendon\xe7a";
        this.additionalText = options.additionalText || '';
    }
    render() {
        const year = new Date().getFullYear();
        const additional = this.additionalText ? ` ${this.additionalText}` : '';
        return `
      <footer class="py-8 bg-white border-t border-slate-200 text-center">
        <p class="text-slate-500 text-sm">
          &copy; <span class="footer-year">${year}</span> ${this.copyrightText}.${additional}
        </p>
      </footer>
    `;
    }
    mount(selector) {
        const element = document.querySelector(selector);
        if (element) element.innerHTML = this.render();
    }
}
var $5b90779196215fa1$export$2e2bcd8739ae039 = $5b90779196215fa1$export$a06f1c675e846f6f;

});

/**
 * Main App
 * Arquivo principal que renderiza os componentes na página index.html
 */ 
var $kAXkN = parcelRequire("kAXkN");
/**
 * Hero Component
 * Componente para a seção hero/banner da página
 */ class $ebdeac93bfdec70d$export$887967f05dc521ae {
    constructor(options = {}){
        this.title = options.title || 'Software Developer';
        this.subtitle = options.subtitle || 'Fullstack';
        this.description = options.description || "Transformo suas ideias em solu\xe7\xf5es digitais robustas";
        this.primaryButton = options.primaryButton || {
            label: "Solicitar Or\xe7amento",
            href: '#contato'
        };
        this.secondaryButton = options.secondaryButton || {
            label: "Ver Portf\xf3lio",
            href: '#projetos'
        };
        this.showScrollIndicator = options.showScrollIndicator !== false;
    }
    render() {
        const scrollIndicator = this.showScrollIndicator ? `<div class="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden md:block">
          <i class="ph ph-caret-down text-slate-400 text-2xl"></i>
        </div>` : '';
        return `
      <section class="relative pt-32 pb-20 md:pt-48 md:pb-32 px-6 overflow-hidden bg-bg-main">
        <!-- Background Elements -->
        <div class="absolute top-0 right-0 w-[500px] h-[500px] bg-blue-100/50 rounded-full blur-3xl -z-10 animate-pulse"></div>
        <div class="absolute bottom-0 left-0 w-96 h-96 bg-indigo-100/50 rounded-full blur-3xl -z-10"></div>

        <div class="max-w-4xl mx-auto text-center relative z-10">
          <div class="inline-flex items-center gap-2 px-3 py-1 mb-8 text-xs font-bold tracking-widest text-brand uppercase bg-blue-50 rounded-full border border-blue-100 animate-fade-in-up">
            <span class="w-2 h-2 rounded-full bg-brand animate-pulse"></span>
            Dispon\xedvel para Freelance
          </div>
          
          <h1 class="text-5xl md:text-7xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
            ${this.title} <br>
            <span class="text-transparent bg-clip-text bg-gradient-to-r from-brand to-cyan-500">${this.subtitle}</span>
          </h1>
          
          <p class="text-lg md:text-xl text-slate-500 mb-10 max-w-2xl mx-auto leading-relaxed">
            ${this.description}
          </p>
          
          <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="${this.primaryButton.href}" class="w-full sm:w-auto px-8 py-4 bg-brand hover:bg-brand-hover text-white font-semibold rounded-lg transition-all shadow-lg shadow-blue-500/20 hover:shadow-blue-500/30 transform hover:-translate-y-1">
              ${this.primaryButton.label}
            </a>
            <a href="${this.secondaryButton.href}" class="w-full sm:w-auto px-8 py-4 bg-white hover:bg-slate-50 text-slate-700 font-medium rounded-lg transition-all border border-slate-200 hover:border-slate-300 shadow-sm">
              ${this.secondaryButton.label}
            </a>
          </div>
        </div>
        
        ${scrollIndicator}
      </section>
    `;
    }
}
var $ebdeac93bfdec70d$export$2e2bcd8739ae039 = $ebdeac93bfdec70d$export$887967f05dc521ae;


/**
 * ServiceCard Component
 * Componente para representar um serviço oferecido
 */ class $347e51e05de39507$export$47e19cb482b7c646 {
    constructor(options = {}){
        this.icon = options.icon || 'ph-desktop';
        this.iconBg = options.iconBg || 'blue-50';
        this.iconColor = options.iconColor || 'text-brand';
        this.hoverBg = options.hoverBg || 'hover:bg-brand';
        this.hoverBorderColor = options.hoverBorderColor || 'hover:border-blue-100';
        this.title = options.title || "T\xedtulo do Servi\xe7o";
        this.description = options.description || "Descri\xe7\xe3o do servi\xe7o";
    }
    render() {
        return `
      <div class="bg-white p-8 rounded-2xl border border-slate-100 shadow-soft ${this.hoverBorderColor} hover:shadow-hover transition-all group">
        <div class="w-14 h-14 bg-${this.iconBg} rounded-xl flex items-center justify-center ${this.iconColor} mb-6 group-hover:${this.hoverBg} group-hover:text-white transition-all">
          <i class="ph ${this.icon} text-3xl"></i>
        </div>
        <h3 class="text-xl font-bold text-slate-900 mb-3">${this.title}</h3>
        <p class="text-slate-500 text-sm leading-relaxed">
          ${this.description}
        </p>
      </div>
    `;
    }
}
var $347e51e05de39507$export$2e2bcd8739ae039 = $347e51e05de39507$export$47e19cb482b7c646;



var $hqDZ9 = parcelRequire("hqDZ9");
/**
 * ContactForm Component
 * Componente reutilizável para o formulário de contato com envio via API
 */ class $bb633fcd80f87abe$export$d5d8fc50aded1148 {
    constructor(options = {}){
        this.options = {
            endpoint: 'https://gabrielmendonca.com.br/api/contact',
            ...options
        };
    }
    async submit(form) {
        const button = document.getElementById('contact-submit') || form.querySelector('button');
        const originalText = button.innerHTML;
        button.disabled = true;
        button.innerHTML = 'Enviando...';
        try {
            const data = new URLSearchParams(new FormData(form));
            const response = await fetch(this.options.endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: data.toString()
            });
            if (!response.ok) throw new Error('Falha no envio');
            this.showModal();
            form.reset();
        } catch (error) {
            console.error(error);
            alert("N\xe3o foi poss\xedvel enviar sua mensagem. Tente novamente mais tarde.");
        } finally{
            button.disabled = false;
            button.innerHTML = originalText;
        }
    }
    showModal() {
        const modal = document.getElementById('contact-modal');
        if (modal) modal.classList.remove('hidden');
    }
    hideModal() {
        const modal = document.getElementById('contact-modal');
        if (modal) modal.classList.add('hidden');
    }
    attachEventListeners() {
        const form = document.getElementById('contact-form');
        if (form) form.addEventListener('submit', (event)=>{
            event.preventDefault();
            this.submit(form);
        });
        const closeBtn = document.getElementById('contact-modal-close');
        const overlay = document.getElementById('contact-modal');
        if (closeBtn && overlay) {
            closeBtn.addEventListener('click', ()=>this.hideModal());
            overlay.addEventListener('click', (event)=>{
                if (event.target === overlay) this.hideModal();
            });
        }
    }
}
var $bb633fcd80f87abe$export$2e2bcd8739ae039 = $bb633fcd80f87abe$export$d5d8fc50aded1148;



var $7Rotq = parcelRequire("7Rotq");
// Initialize Navigation
const $4fc5e34bd161c544$var$navigation = new (0, $kAXkN.Navigation)({
    homeLink: '#',
    links: [
        {
            href: '#servicos',
            label: "O que fa\xe7o"
        },
        {
            href: 'portfolio.html',
            label: "Portf\xf3lio"
        },
        {
            href: 'projetos.html',
            label: 'GitHub'
        },
        {
            href: '#sobre',
            label: 'Sobre',
            hidden: false
        }
    ],
    ctaButton: {
        href: '#contato',
        label: 'Fale Comigo'
    }
});
$4fc5e34bd161c544$var$navigation.mount('#app-navbar');
// Initialize Hero
const $4fc5e34bd161c544$var$hero = new (0, $ebdeac93bfdec70d$export$887967f05dc521ae)({
    title: 'Software Developer',
    subtitle: 'Fullstack',
    description: 'Especialista em criar solu\xe7\xf5es digitais robustas. Transformo sua ideia em <span class="text-slate-800 font-semibold">Aplicativos, Softwares e Web Sites</span> modernos e escal\xe1veis.',
    primaryButton: {
        href: '#contato',
        label: "Solicitar Or\xe7amento"
    },
    secondaryButton: {
        href: '#projetos',
        label: "Ver Portf\xf3lio"
    }
});
const $4fc5e34bd161c544$var$heroSection = document.getElementById('hero-section');
if ($4fc5e34bd161c544$var$heroSection) $4fc5e34bd161c544$var$heroSection.innerHTML = $4fc5e34bd161c544$var$hero.render();
// Initialize Services
const $4fc5e34bd161c544$var$services = [
    {
        icon: 'ph-desktop',
        iconBg: 'blue-50',
        iconColor: 'text-brand',
        title: 'Sites Institucionais',
        description: "Sites r\xe1pidos, otimizados para SEO e responsivos. A primeira impress\xe3o perfeita para sua empresa.",
        hoverBorderColor: 'hover:border-blue-100'
    },
    {
        icon: 'ph-code',
        iconBg: 'purple-50',
        iconColor: 'text-purple-600',
        title: 'Sistemas Web',
        description: "Dashboards, CRMs e plataformas SaaS. Automa\xe7\xe3o e controle para processos complexos.",
        hoverBorderColor: 'hover:border-purple-100',
        hoverBg: 'hover:bg-purple-600'
    },
    {
        icon: 'ph-device-mobile',
        iconBg: 'green-50',
        iconColor: 'text-green-600',
        title: 'Aplicativos Mobile',
        description: 'Apps para Android e iOS usando tecnologias modernas para garantir alta performance.',
        hoverBorderColor: 'hover:border-green-100',
        hoverBg: 'hover:bg-green-600'
    }
];
const $4fc5e34bd161c544$var$servicesContainer = document.getElementById('services-container');
if ($4fc5e34bd161c544$var$servicesContainer) $4fc5e34bd161c544$var$services.forEach((service)=>{
    const card = new (0, $347e51e05de39507$export$47e19cb482b7c646)(service);
    $4fc5e34bd161c544$var$servicesContainer.innerHTML += card.render();
});
// Initialize Projects
const $4fc5e34bd161c544$var$projects = [
    {
        title: "Cl\xednica \xc1gil",
        description: "Plataforma de agendamento para cl\xednicas com lembretes autom\xe1ticos por WhatsApp, prontu\xe1rio digital e gest\xe3o de profissionais.",
        icon: 'ph-first-aid-kit',
        image: 'assets/projects/clinica-agil.webp',
        tags: [
            'React',
            'Node.js',
            'PostgreSQL'
        ]
    },
    {
        title: 'Fazenda Direto',
        description: "Marketplace que conecta produtores rurais a consumidores, com log\xedstica de entrega regional e pagamento integrado.",
        icon: 'ph-basket',
        image: 'assets/projects/fazenda-direto.webp',
        tags: [
            'React Native',
            'Firebase'
        ]
    },
    {
        title: 'Fitness Tracker',
        description: "Aplicativo de treinos personalizados com planos adaptativos, acompanhamento de evolu\xe7\xe3o e metas di\xe1rias.",
        icon: 'ph-barbell',
        image: 'assets/projects/fitness-tracker.webp',
        tags: [
            'React Native',
            'Node.js'
        ]
    },
    {
        title: 'Recrutamento Tech',
        description: "Plataforma de vagas para devs com triagem autom\xe1tica por desafios t\xe9cnicos, ranking de candidatos e feedback estruturado.",
        icon: 'ph-briefcase',
        image: 'assets/projects/recrutamento-tech.webp',
        tags: [
            'Next.js',
            'MongoDB'
        ]
    },
    {
        title: 'Bot de Atendimento',
        description: "Assistente de WhatsApp com respostas autom\xe1ticas, qualifica\xe7\xe3o de leads e transfer\xeancia inteligente para atendimento humano.",
        icon: 'ph-chats-circle',
        image: 'assets/projects/bot-atendimento.webp',
        tags: [
            'Node.js',
            'WhatsApp API'
        ]
    },
    {
        title: 'API de Pagamentos',
        description: "Gateway de pagamentos com assinaturas recorrentes, gest\xe3o de faturas, webhooks e painel administrativo em tempo real.",
        icon: 'ph-credit-card',
        image: 'assets/projects/api-pagamentos.webp',
        tags: [
            'Node.js',
            'Express',
            'Stripe'
        ]
    }
];
const $4fc5e34bd161c544$var$projectsContainer = document.getElementById('projects-container');
if ($4fc5e34bd161c544$var$projectsContainer) $4fc5e34bd161c544$var$projects.forEach((project)=>{
    const card = new (0, $hqDZ9.ProjectCard)(project);
    $4fc5e34bd161c544$var$projectsContainer.innerHTML += card.render();
});
// Initialize Footer
const $4fc5e34bd161c544$var$footer = new (0, $7Rotq.Footer)({
    copyrightText: "Gabriel Mendon\xe7a",
    additionalText: 'Feito com <i class="ph-fill ph-heart text-red-500 align-middle"></i> e muito caf\xe9.'
});
$4fc5e34bd161c544$var$footer.mount('#app-footer');
// Initialize Contact Form
const $4fc5e34bd161c544$var$contactForm = new (0, $bb633fcd80f87abe$export$d5d8fc50aded1148)();
$4fc5e34bd161c544$var$contactForm.attachEventListeners();
// Mobile menu toggle
const $4fc5e34bd161c544$var$mobileMenuBtn = document.getElementById('mobile-menu-btn');
const $4fc5e34bd161c544$var$mobileMenu = document.getElementById('mobile-menu');
const $4fc5e34bd161c544$var$navLinks = document.querySelectorAll('.mobile-link');
if ($4fc5e34bd161c544$var$mobileMenuBtn && $4fc5e34bd161c544$var$mobileMenu) {
    $4fc5e34bd161c544$var$mobileMenuBtn.addEventListener('click', ()=>{
        $4fc5e34bd161c544$var$mobileMenu.classList.toggle('hidden');
    });
    $4fc5e34bd161c544$var$navLinks.forEach((link)=>{
        link.addEventListener('click', ()=>{
            $4fc5e34bd161c544$var$mobileMenu.classList.add('hidden');
        });
    });
}
// Navbar scroll effect
const $4fc5e34bd161c544$var$navbar = document.getElementById('app-navbar');
window.addEventListener('scroll', ()=>{
    const nav = $4fc5e34bd161c544$var$navbar.querySelector('nav');
    if (nav) {
        if (window.scrollY > 50) nav.classList.add('shadow-md');
        else nav.classList.remove('shadow-md');
    }
});


//# sourceMappingURL=novoSite.46e0d53e.js.map
